'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VstListItem = require('./VstListItem');

var _VstListItem2 = _interopRequireDefault(_VstListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstPopover = function (_React$Component) {
  _inherits(VstPopover, _React$Component);

  function VstPopover(props) {
    _classCallCheck(this, VstPopover);

    var _this = _possibleConstructorReturn(this, (VstPopover.__proto__ || Object.getPrototypeOf(VstPopover)).call(this, props));

    _this.createPortal = _this.createPortal.bind(_this);
    _this.onDocumentMouseUp = _this.onDocumentMouseUp.bind(_this);
    return _this;
  }

  _createClass(VstPopover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPortal();
      this.doRender(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.doRender(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.portal) {
        _reactDom2.default.unmountComponentAtNode(this.portal);
        document.body.removeChild(this.portal);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'createPortal',
    value: function createPortal() {
      this.portal = document.createElement('div');
      this.portal.setAttribute('class', 'vst-popover');
      document.body.appendChild(this.portal);
    }
  }, {
    key: 'doRender',
    value: function doRender(props) {
      _reactDom2.default.render(this.renderComponent(props), this.portal);
    }
  }, {
    key: 'onDocumentMouseUp',
    value: function onDocumentMouseUp(e) {
      var portal = (0, _reactDom.findDOMNode)(this.portal);
      if (portal && portal.contains(e.target) || e.button && e.button !== 0) return;
      e.stopPropagation();
    }
  }, {
    key: 'renderComponent',
    value: function renderComponent(props) {
      var className = props.className,
          style = props.style,
          children = props.children,
          onBackdropClick = props.onBackdropClick,
          showOverlay = props.showOverlay,
          restProps = _objectWithoutProperties(props, ['className', 'style', 'children', 'onBackdropClick', 'showOverlay']);

      return _react2.default.createElement(
        'div',
        null,
        showOverlay && _react2.default.createElement('div', { className: 'vst-popover-overlay', onClick: onBackdropClick }),
        _react2.default.createElement(
          'div',
          _extends({
            style: _extends({ position: 'fixed' }, style),
            className: 'vst-list ' + className
          }, restProps),
          children
        )
      );
    }
  }]);

  return VstPopover;
}(_react2.default.Component);

VstPopover.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  onBackdropClick: _propTypes2.default.func,
  showOverlay: _propTypes2.default.bool,
  style: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    left: _propTypes2.default.number
  })
};

VstPopover.defaultProps = {
  className: '',
  open: false,
  showOverlay: false,
  style: {}
};

VstPopover.Item = _VstListItem2.default;

exports.default = VstPopover;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstPopover.js
 **/